import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { palette } from '../../../../assets/styles/themes/tokens';

interface ToolbarIconButtonProps {
  title: string;
  dataTestId?: string;
  icon: React.ReactNode;
  onClick: () => void;
  isActive?: boolean;
  disabled?: boolean;
}

const ToolbarIconButton: React.FC<ToolbarIconButtonProps> = ({
  title,
  dataTestId,
  icon,
  onClick,
  isActive = false,
  disabled = false,
}) => {
  return (
    <Tooltip title={title} leaveDelay={0} leaveTouchDelay={0}>
      <IconButton
        data-testid={dataTestId}
        color='secondary'
        size='small'
        onClick={onClick}
        disabled={disabled}
        sx={{
          backgroundColor: isActive ? alpha(palette.primary.main, 0.08) : 'transparent',
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default ToolbarIconButton;

